import { Box, Button, ButtonProps, chakra, Circle, Text } from '@chakra-ui/react';
import { forwardRef, LegacyRef } from 'react';
import { useTranslation } from 'react-i18next';

type Props = { selectedCount: number } & ButtonProps;
type Ref = LegacyRef<HTMLButtonElement>;

export const BulkActionButton = forwardRef(function BulkButton(
  { selectedCount, ...props }: Props,
  ref: Ref,
) {
  const { t } = useTranslation();

  return (
    <Button ref={ref} variant="outline" colorScheme="gray" {...props}>
      <Text>{t('bulkActions')}</Text>
      <Box paddingLeft="3">
        <Circle size="24px" background="white">
          <chakra.span color="blue.500" fontSize="sm" mb="0.5">
            {selectedCount}
          </chakra.span>
        </Circle>
      </Box>
    </Button>
  );
});
